/** Refactor common components styles */

const Styles = {
  dropDownBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    color: '#4a4a4a',
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    outlineWidth: 2,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 12,
    paddingRight: 12,
    height: 32
  },
  fieldDisplay: {
    color: '#4a4a4a',
    fontSize: 14,
    marginBottom: 4
  },
  textareaInput: {
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    padding: 8,
    fontSize: 14,
    outlineWidth: 2,
    color: '#4a4a4a',
    resize: 'vertical'
  },
  fieldInput: {
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    height: 32,
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: 14,
    outlineWidth: 2,
    color: '#4a4a4a',
    flex: 1
  },
  validationError: {
    color: '#f00',
    fontSize: 12,
    marginTop: 4
  },
  noLogoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed #E0E0E0',
    width: 121,
    height: 121,
    color: '#9b9b9b',
    fontSize: 22
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/billing/common/Styles.js